/**
 * Pinia store initialization
 * Central state management configuration
 */

import { createPinia } from 'pinia'

/**
 * Create Pinia instance
 * This will be installed in main.ts
 */
const pinia = createPinia()

export default pinia